import {
  registerDashboardWidget,
  setDashboardWidgetLayout,
} from "@bb-vendure/admin-ui/core";

export default [
  // Add your providers here
  registerDashboardWidget("sale", {
    title: "Sales By Country",
    supportedWidths: [4, 6, 8, 12],
    loadComponent: () =>
      import("./components/sale-by-country-widget.component").then(
        (m) => m.SaleWidgetComponent
      ),
  }),
  // 覆盖默认的 latestOrders widget
    registerDashboardWidget("latestOrders", {
        title: "dashboard.latest-orders",
        supportedWidths: [4, 6, 8, 12],
        loadComponent: () =>
            import("./components/last-order-widget.component").then(
                (m) => m.CustomLatestOrdersWidgetComponent
            ),
    }),
  setDashboardWidgetLayout([
    { id: "welcome", width: 12 },
    { id: "orderSummary", width: 4 },
    { id: "latestOrders", width: 8 },
    { id: "sale", width: 12 },
  ]),
];
